// extracted by mini-css-extract-plugin
export default {"whatsappFloat":"WhatsApp_whatsappFloat__lmiYQ","whatsappIcon":"WhatsApp_whatsappIcon__kLgOn","pulse":"WhatsApp_pulse__h4FRL"};